<template>
  <div>
    <b-button variant="primary" @click="$bvModal.show('leaveFormModal')" size="xl">
      Form for Leave Application
    </b-button>
    <br><br>
    <div v-if="loading" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary" class="mr-2"></b-spinner>
      <span class="font-weight-bold">Loading leave data...</span>
    </div>
    <div v-else>
      <table class="table table-striped table-bordered">
        <thead class="thead-dark text-left">
          <tr>
            <th>SI. No.</th>
            <th>Session</th>
            <th>Leave Type</th>
            <th>Event Name</th>
            <th>Reason</th>
            <th>Attachment</th>
            <th>Status</th>
            <th v-if="mandatory_event_coordinator">Forwarded By & At</th>
            <th v-if="student_leave_approval_level == '2' || student_leave_approval_level == '3'">Recommended By & At
            </th>
            <th v-if="student_leave_approval_level == '3'">Verified By & At</th>
            <th>Approved By & At</th>
            <th>Rejected By & At</th>
            <th>Reason For Reject</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, sindex) in studentLeaveLists" :key="sindex">
            <td>{{ sindex + 1 }}</td>
            <td>
              <div v-if="studentLeaveSessions[student.id]">
                <div v-for="(sessionsOnDate, date) in groupByDate(studentLeaveSessions[student.id])" :key="date">
                  {{ formatDate(date) }} -
                  <span v-for="(leave, index) in sessionsOnDate" :key="leave.id">
                    {{ leave.session.name }} ({{ leave.course.code }})
                    <span v-if="index < sessionsOnDate.length - 1">, </span>
                  </span>
                </div>
              </div>
            </td>

            <td>{{ student.attendancetype ? student.attendancetype.name : '' }}</td>

            <td>
              <span v-if="student.attendancetype && student.attendancetype.name == 'Duty Leave'">
                {{ student.event ? student.event.name : 'Not Applicable' }}
              </span>
              <span v-if="student.attendancetype && student.attendancetype.name == 'Medical Leave'
                && mandatory_event_coordinator">
                Not Applicable
              </span>
            </td>

            <td>{{ student.leave_reason }}</td>
            <td class="text-center">
              <a v-if="student.files && student.files.length > 0" :href="getFileUrl(student.files[0])" target="_blank"
                class="inline-block">
                <i class="fas fa-paperclip text-gray-600" style="font-size: 12px;"></i>
              </a>
            </td>
            <td>
              <template>
                <!-- REJECT FIRST -->
                <span v-if="firstRejectedBy(student)"
                      class="text-danger font-weight-bold">
                  Rejected
                </span>

                <!-- FORWARDED BLOCK -->
                <span v-else-if="isForwarded(student)">

                  <!-- forwarded + approved -->
                  <span v-if="firstApprovedBy(student)"
                        class="text-success font-weight-bold">
                    Approved
                  </span>

                  <!-- forwarded + recommended -->
                  <span v-else-if="firstRecommendedBy(student)"
                        class="text-info font-weight-bold">
                    Recommended
                  </span>

                  <!-- forwarded + verified -->
                  <span v-else-if="firstVerifiedBy(student)"
                        class="text-primary font-weight-bold">
                    Verified
                  </span>

                  <!-- only forwarded -->
                  <span v-else class="text-purple font-weight-bold">
                    Forwarded
                  </span>
                </span>

                <!-- OLD LOGIC (NO FORWARD) -->
                <span v-else-if="firstApprovedBy(student)"
                      class="text-success font-weight-bold">
                  Approved
                </span>

                <span v-else-if="firstRecommendedBy(student)"
                      class="text-info font-weight-bold">
                  Recommended
                </span>

                <span v-else-if="firstVerifiedBy(student)"
                      class="text-primary font-weight-bold">
                  Verified
                </span>

                <span v-else class="text-warning font-weight-bold">
                  Pending
                </span>
              </template>
            </td>

             <td v-if="mandatory_event_coordinator">
              <template v-if="isForwarded(student)">
                <template v-if="isForwarded(student).action_by_user">
                  {{
                  isForwarded(student).action_by_user.first_name + ' ' +
                  isForwarded(student).action_by_user.last_name
                  }}<br>
                </template>
                {{ formatDate(isForwarded(student).action_at) }}
              </template>
            </td>

            <td v-if="student_leave_approval_level === 2 || student_leave_approval_level === 3">
              <template v-if="firstRecommendedBy(student)">
                <template v-if="firstRecommendedBy(student).action_by_user">
                  {{
                  firstRecommendedBy(student).action_by_user.first_name + ' ' +
                  firstRecommendedBy(student).action_by_user.last_name
                  }}<br>
                </template>
                {{ formatDate(firstRecommendedBy(student).action_at) }}
              </template>
            </td>

            <td v-if="student_leave_approval_level === 3">
              <template v-if="firstVerifiedBy(student)">
                <template v-if="firstVerifiedBy(student).action_by_user">
                  {{
                  firstVerifiedBy(student).action_by_user.first_name + ' ' +
                  firstVerifiedBy(student).action_by_user.last_name
                  }}<br>
                </template>
                {{ formatDate(firstVerifiedBy(student).action_at) }}
              </template>
            </td>

            <td>
              <template v-if="firstApprovedBy(student)">
                <template v-if="firstApprovedBy(student).action_by_user">
                  {{
                  firstApprovedBy(student).action_by_user.first_name + ' ' +
                  firstApprovedBy(student).action_by_user.last_name
                  }}<br>
                </template>
                {{ formatDate(firstApprovedBy(student).action_at) }}
              </template>
            </td>

            <td>
              <template v-if="firstRejectedBy(student)">
                <template v-if="firstRejectedBy(student).action_by_user">
                  {{
                  firstRejectedBy(student).action_by_user.first_name + ' ' +
                  firstRejectedBy(student).action_by_user.last_name
                  }}<br>
                </template>
                {{ formatDate(firstRejectedBy(student).action_at) }}
              </template>
            </td>

           
            <td>{{ student.reject_reason }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal id="leaveFormModal" no-close-on-backdrop no-close-on-keyboard hide-footer hide-header centered size="xl">
      <div>
        <label>Start Date <span class="text-danger">*</span></label>
        <b-form-datepicker v-model="studentleave.start_date" placeholder="Select Start Date"></b-form-datepicker>
        <span class="text-danger" v-if="$v.studentleave.start_date.$error">Start Date is required.</span>
        <br>

        <label>End Date <span class="text-danger">*</span></label>
        <b-form-datepicker v-model="studentleave.end_date" placeholder="Select End Date"></b-form-datepicker>
        <span class="text-danger" v-if="$v.studentleave.end_date.$error">End Date is required.</span>
        <br>
        <div class="table-responsive rounded" v-if="studentleave.start_date && studentleave.end_date">
          <span class="text-danger" v-if="$v.studentleave.checkedDateSessionAbsents.$error">
            Please select at least one absent session.
          </span>

          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th colspan="100" class="text-center">Absent Marked Sessions</th>
              </tr>
              <tr>
                <th></th>
                <th v-for="(session, sessionIndex) in sessions" :key="sessionIndex" class="text-capitalize">
                  {{ session.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(attDate, attIndex) in attendanceDates" :key="attIndex">
                <td>{{ attDate.date }} - {{ attDate.day }}</td>
                <td v-for="(session, sessionIndex) in sessions" :key="sessionIndex" class="text-center">
                  <template v-if="studentAttendanceData[attDate.key][session.id].attendance">
                    <template
                      v-if="attendanceTypes[studentAttendanceData[attDate.key][session.id].attendance].code === 'AB'">
                      <input type="checkbox"
                        v-model="studentleave.checkedDateSessionAbsents[`${attDate.key}_${session.id}`]" class="mr-1"
                        @change="handleCheckboxChange(attDate, session)" />
                      {{
                      attendanceTypes[studentAttendanceData[attDate.key][session.id].attendance].code
                      }}<br />
                      <span class="course">
                        {{
                        courses[studentAttendanceData[attDate.key][session.id].course].code
                        }}
                      </span>
                    </template>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <label>Leave Type <span class="text-danger">*</span></label>
        <b-form-select v-model="studentleave.attendence_type_id" :options="attendenceTypes"></b-form-select>
        <span class="text-danger" v-if="$v.studentleave.attendence_type_id.$error">Leave Type is
          required.</span>
        <br>

        <!-- Show Events only if "Duty Leave" selected -->
        <div v-if="isDutyLeave && mandatory_event_coordinator">
          <label>Events <span class="text-danger">*</span></label>
          <b-form-select v-model="studentleave.event_id" :options="eventList">
          </b-form-select>
          <span class="text-danger" v-if="$v.studentleave.event_id.$error">
            Event is required.
          </span>
          <br>
        </div>

        <label>Reason <span class="text-danger">*</span></label>
        <b-form-input v-model="studentleave.leave_reason" type="text"></b-form-input>
        <span class="text-danger" v-if="$v.studentleave.leave_reason.$error">Reason is required.</span>
        <br>

        <label>Attachment (PDF only, max 100 KB)</label>
        <input type="file" ref="fileInput" @change="updateAttach" accept=".pdf" />
        <i v-if="studentleave.attachment" class="fas fa-trash text-danger" style="font-size: 12px !important;"
          @click="removeAttachment"></i>

        <br />
        <span v-if="usersubgroup && usersubgroup['name']" class="text-danger">
          Leave Request will be submitted for {{ usersubgroup['name'] }}, {{ usersubgroup['academic_year'] }} {{
          usersubgroup['academic_semester'] }}.
        </span>

        <div class="text-center mt-3">
          <b-button v-if="!saveApplication" variant="success" size="sm" class="mr-2 w-25"
            @click="saveStudentLeave">Apply</b-button>
          <span v-else class="text-success">Please wait, saving in progress...</span>
          <b-button variant="danger" size="sm" class="w-25" @click="closeModal">Close</b-button>
        </div>

      </div>
    </b-modal>

  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
function atLeastOneSelected(value) {
  if (!value || typeof value !== 'object') return false;
  return Object.values(value).some(v => v === true);
}

required;
import axios from "axios";
export default {
  data() {
    return {
      loading: true,
      eventList: [],
      mandatory_event_coordinator: false,
      studentleave: {
        start_date: null,
        end_date: null,
        all_day: 0,
        // session_id: null,
        checkedDateSessionAbsents: {},
        attendence_type_id: null,
        event_id: null,
        leave_reason: null,
        attachment: null,
      },
      studentLeaveSessions: [],
      sessions: [],
      attendenceTypes: [],
      studentLeaveLists: [],
      student_leave_approval_level: "1",
      usersubgroup: [],
      cloudStorageRoot: '',
      studentLeaveAttachments: {},//id:{id, url, name}
      saveApplication: false,
      absentRecords: [],
      courses: {},
      studentAttendanceData: {},
      attendanceDates: {},
    };
  },
  async created() {
    await this.fetchData();
    this.cloudStorageRoot = await this.$store.getters.getAPIKey.userAttachments;
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getStudentLeave(); // replace with your real data-fetching method
    } catch (e) {
      console.error("Error fetching leave data:", e);
    } finally {
      this.loading = false;
    }
  },
  validations() {
    return {
      studentleave: {
        start_date: { required },
        end_date: { required },
        attendence_type_id: { required },
        event_id: {
          required: function () {
            return this.isDutyLeave && this.mandatory_event_coordinator
              ? required
              : () => true; // no validation when not duty leave or not mandatory
          }
        },
        leave_reason: { required },
        checkedDateSessionAbsents: { atLeastOneSelected },
      },
    };
  },
  watch: {
    'studentleave.start_date'(newVal) {
      if (newVal && this.studentleave.end_date) {
        this.getStudentAttendanceDetailedReport();
      }
    },
    'studentleave.end_date'(newVal) {
      if (newVal && this.studentleave.start_date) {
        this.getStudentAttendanceDetailedReport();
      }
    }
  },
  computed: {
    isDutyLeave() {
      const selected = this.attendenceTypes.find(
        a => a.value == this.studentleave.attendence_type_id
      );
      return selected && selected.text === "Duty Leave";
    }
  },
  methods: {
    isForwarded(student) {
      return student.approvers.find(a => a.action_type === 'forward' && a.action_by !== null);
    },
    firstApprovedBy(student) {
      return student.approvers.find(a => a.action_type === 'approve' && a.action_by !== null);
    },
    firstRecommendedBy(student) {
      return student.approvers.find(a => a.action_type === 'recommend' && a.action_by !== null);
    },
    firstVerifiedBy(student) {
      return student.approvers.find(a => a.action_type === 'verify' && a.action_by !== null);
    },
    firstRejectedBy(student) {
      return student.approvers.find(a => a.action_type === 'reject' && a.action_by !== null);
    },
    groupByDate(sessions) {
      const grouped = {};
      sessions.forEach(session => {
        if (!grouped[session.date]) {
          grouped[session.date] = [];
        }
        grouped[session.date].push(session);
      });
      return grouped;
    },
    handleCheckboxChange(attDate, session) {
      const key = `${attDate.key}_${session.id}`;
      const checked = this.studentleave.checkedDateSessionAbsents[key];

      const attendanceEntry = this.studentAttendanceData[attDate.key][session.id];

      const dataKey = {
        date: attDate.date,
        session_id: session.id
      };

      if (checked) {
        const dataToSave = {
          ...dataKey,
          course_id: attendanceEntry.course,
          marked_by: attendanceEntry.marked_by
        };

        // Avoid duplicate entry
        const exists = this.absentRecords.some(
          item => item.date === dataToSave.date && item.session_id === dataToSave.session_id
        );

        if (!exists) {
          this.absentRecords.push(dataToSave);
        }
      } else {
        // Remove the unchecked item
        this.absentRecords = this.absentRecords.filter(
          item => !(item.date === dataKey.date && item.session_id === dataKey.session_id)
        );
      }
    },
    getStudentAttendanceDetailedReport() {
      this.loadData = true;
      let mainUrl = this.$store.getters.getAPIKey.mainAPI;
      let url = "";
      let params = {};
      url = `${mainUrl}/attendancereports/student/detailed`;
      params = {
        start_date: this.studentleave.start_date,
        upto_date: this.studentleave.end_date,
        from_student_leave_application: true
      };
      this.$axios
        .post(url, params)
        .then((response) => {
          let responseData = response.data;
          this.courses = responseData.courses;
          this.sessions = responseData.sessions;
          this.attendanceTypes = responseData.attendanceTypes;
          this.studentAttendanceData = responseData.studentAttendanceData;
          this.attendanceDates = responseData.attendanceDatesArray;
          this.loadData = false;
        })
        .catch((error) => {
          error;
          this.loadData = false;
        });
    },
    closeModal() {
      this.$bvModal.hide('leaveFormModal');
      this.resetLeaveForm();
    },
    getFileUrl(file) {
      return this.cloudStorageRoot + file.file_path + file.file_name;
    },
    /** Fetch all necessary data on component creation */
    async fetchData() {
      await this.getStudentLeaveSettings();
      await this.fetchEvents();
      await this.getSessions();
      await this.getAttendanceTypes();
      await this.getUserSubgroup();
      await this.getStudentLeave();
    },

    async fetchEvents() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/events`;
      await this.$axios
        .get(url)
        .then((res) => {
  
          this.eventList = [
            { value: null, text: "Not Applicable" }
          ];

          res.data.forEach(event => {
            this.eventList.push({
              value: event.id,
              text: event.name
            });
          });
        })
        .catch(() => { });
    },

    async getStudentLeaveSettings() {
      this.fetchData = true;
      const settingKey = "student_leave_approval_level";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);

      await axios
        .get(url)
        .then((response) => {
          this.student_leave_approval_level = response.data ? response.data : '1';
        })
        .catch(() => {
          this.$toast.error("Failed to load student leave settings", {
            top: "top",
            duration: 6000,
          });
        });

      /* ---- mandatory_event_coordinator Setting ---- */
      const settingKey2 = "mandatory_event_coordinator";
      const url2 = mainUrl.replace("setting_key", settingKey2);

      await axios.get(url2)
        .then((response) => {
          this.mandatory_event_coordinator = response.data == 1 ? true : false;
        })
        .catch(() => {});

      this.fetchData = false; 
    },

    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('en-GB'); // 'en-GB' formats as dd/mm/yyyy
    },

    async getUserSubgroup() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/usersubgroups`;
      await this.$axios.get(url).then((res) => {
        this.usersubgroup = res.data[0];
      });
    },

    /** Fetch student leave records */
    async getStudentLeave() {
      try {
        const response = await axios.get(`${this.$store.getters.getAPIKey.mainAPI}/studentleaves`);
        this.studentLeaveLists = response.data.student_leaves;
        this.studentLeaveSessions = response.data.student_leave_sessions;
      } catch (error) {
        console.error("Error fetching student leave data:", error);
      }
    },

    /** Save student leave details with attachment */
    async saveStudentLeave() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        this.saveApplication = true;

        const formData = new FormData();
        Object.entries(this.studentleave).forEach(([key, value]) => {
          if (value) formData.append(key, value);
        });

        formData.append("absentRecords", JSON.stringify(this.absentRecords));

        if (this.usersubgroup?.id) {
          formData.append("usersubgroup_id", this.usersubgroup.id);
        }

        formData.append(
          "student_leave_approval_level",
          this.student_leave_approval_level || '1'
        );

        await axios.post(`${this.$store.getters.getAPIKey.mainAPI}/studentleaves`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        this.$toast.success("Successfully Saved", { position: "top", duration: 3000 });
        this.resetLeaveForm();
        await this.getStudentLeave();
        this.$bvModal.hide("leaveFormModal");

      } catch (error) {
        console.error("Error saving student leave:", error);
      } finally {
        this.saveApplication = false;
      }
    },


    /** Reset leave form data */
    resetLeaveForm() {
      // Reset main leave data
      this.studentleave = {
        start_date: null,
        end_date: null,
        all_day: 0,
        session_id: [],
        checkedDateSessionAbsents: {},
        attendence_type_id: null,
        event_id: null,
        leave_reason: null,
        attachment: null,
      };

      // Clear temporary arrays
      this.absentRecords = [];
      this.studentLeaveSessions = [];

      // Clear file input manually
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }

      // Reset validation
      if (this.$v) {
        this.$v.$reset();
      }
    },

    /** Fetch attendance types */
    async getAttendanceTypes() {
      try {
        const response = await axios.get(this.$store.getters.getAPIKey.attendenceType);
        this.attendenceTypes = response.data
          .filter(type => type.positive_report_value === 1)
          .map(type => ({ value: type.id, text: type.name }));
      } catch (error) {
        console.error("Error fetching attendance types:", error);
      }
    },

    /** Handle file attachment */
    updateAttach(event) {
      const file = event.target.files[0];
      const maxSize = 100 * 1024; // 100 KB in bytes

      if (!file) return;

      if (file.type !== "application/pdf") {
        alert("Please upload a valid PDF file.");
        event.target.value = "";
        return;
      }

      if (file.size > maxSize) {
        alert("File size must be less than or equal to 100 KB.");
        event.target.value = "";
        return;
      }

      this.studentleave.attachment = file;
    },

    /** Remove attachment */
    removeAttachment() {
      this.studentleave.attachment = null;
      this.$refs.fileInput.value = ""; // Clear file input
    },

    /** Fetch available sessions */
    async getSessions() {
      try {
        const response = await axios.get(this.$store.getters.getAPIKey.createSessions);
        this.sessions = response.data;
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    },
  },
};
</script>
<style scoped>
.studentLeave .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed;
  z-index: 100000;
}

.studentLeave .modal-body {
  overflow: scroll;
}

.studentLeave .fixed-table-column {
  position: sticky;
  left: 0;
  background-color: gray;
}
</style>